export function addConnectorsToList(languages: string[]): string | undefined {
  if (languages.length === 0) {
    return undefined
  }

  const { t, locale } = useI18n()
  const lastElement = languages[languages.length - 1]
  let separator = t('lang.connectors.addition')

  if (locale.value === 'es-ES') {
    separator = lastElement[0].toLowerCase() !== 'i' ? 'y' : 'e'
  }

  if (languages.length > 2) {
    const firstElements = languages.slice(0, -1).join(', ')
    return `${firstElements} ${separator} ${lastElement}`
  } else {
    return languages.join(` ${separator} `)
  }
}
